import { createBrowserHistory } from 'history';

// Create a custom history instance that can be imported and used
// in Redux actions and other non-component code
const history = createBrowserHistory({
  basename: '/app',
});

export default history;
